import React, { createElement as e, useMemo } from 'react';
import { RemarkContext } from './context';
import { Client, ClientOptions, initialize } from '@outdoorly/chat-sdk';

type ClientProp = { client: Client } & { [key in keyof ClientOptions]?: never };
type ClientOptionsProp = ClientOptions & { client?: never };
export type RemarkProviderProps = (ClientOptionsProp | ClientProp) & { children?: React.ReactNode };
/**
 * uses the client if one is provided, creates one with supplied arguments if one is not
 */
export const RemarkProvider: React.FC<RemarkProviderProps> = ({
  children,
  client: propClient,
  ...options
}) => {
  // check that we can add a client to the provider!
  if (!propClient && !options.shopUrl) throw new Error('must provide a client or shopUrl');
  const client = useMemo(() => propClient ?? initialize(options as ClientOptions), []);
  return e(RemarkContext.Provider, { value: { client, inProvider: true } }, children);
};
